import request from '../request'

export const getTenant = () => request.get('tenant').then((res) => res)

export const getTenantCurriculum = (params) => request.get('tenant/curriculum', { params }).then((res) => res)

export const updateTenant = (data) => request.put('tenant', data).then((res) => res)

export const updateLicense = (data) => request.put('tenant/license', data).then((res) => res)

export const updateCurriculum = (data) => request.put('tenant/curriculum', data).then((res) => res)

export const updateReadOnly = (data) => request.put('setting/read-only', data).then((res) => res)

export const updateTenantLogo = (data) => request.put('tenant/logo', data).then((res) => res)

// MF-67 — save the school geo centre { lat, lng }.
export const updateGeo = (data) => request.put('tenant/geo', data).then((res) => res)
